export class UserModel {
    currentUserName: string;
    currentUserInitials: string;
    currentUserEmail: string;
    currentPasswordSetDate: string;
    currentPasswordExpireDate: string;
    currentPasswordExpired: string;
    currentPasswordWarnDays: string;
}
